export default {
  header: {
    navigation: {
      about: "Nous connaître",
      resources: "Ressources",
      directory: "Annuaire Artisans RGE",
    },
    menu: "Menu",
  },
  home: {
    hero: {
      title1: "Devenez Ambassadeur chez",
      title2: "projetsolaire.",
      subtitle: "Participez à la Révolution Solaire et Gagnez en Même Temps!",
      button: "Commencer",
      "learn-more": "En savoir plus",
      badge: "Accélerons la révolution solaire, ensemble.",
      "badge-link": "En savoir plus sur nous",
      "current-title": "Parrainez. Gagnez 500 €.<br/>Sauvez la planète.",
      "current-description":
        "Soyez rémunéré pour partager les bienfaits de l'énergie solaire à vos voisins, proches et collègues. Et aidez-nous à changer le monde.",
      label: "Accélérons la révolution solaire, ensemble.",
      "button-label": "Devenir ambassadeur",
      "image-alt": "Image d'illustration du programme d'ambassadeur",
    },
    why: {
      whyup: "Pourquoi ?",
      title: "Pourquoi devenir un ambassadeur de l'énergie solaire ?",
      reason1: {
        title: "Impact Environnemental :",
        description:
          "Contribuez à la lutte contre le changement climatique en promouvant une source d'énergie propre et renouvelable.",
      },
      reason2: {
        title: "Revenus Supplémentaires :",
        description:
          "Gagnez de l'argent en recommandant nos services et en aidant les propriétaires à passer à l'énergie solaire.",
      },
      reason3: {
        title: "Formation et Soutien :",
        description:
          "Bénéficiez d'une formation complète et d'un soutien continu pour réussir en tant qu'ambassadeur.",
      },
      reason4: {
        title: "Flexibilité :",
        description:
          "Travailler à votre rythme, où vous le souhaitez, en fonction de vos horaires et de votre style de vie.",
      },
      caption:
        '"J’ai déjà parrainé deux amis et j’ai pu les accompagner dans leur parcours vers l’autoconsommation. Leurs installations se sont déroulées rapidement, ils sont ravis. Tout le monde est gagnant !"',
    },
    benefits: {
      title: "Pourquoi faire du bouche-à-oreille du soleil ?",
      description:
        "Déjà des milliers de projets solaires, et voici quelques raisons impérieuses pour vous aider à faire passer le mot sur l'énergie solaire.",
      items: {
        nothing: {
          title: "Rien à faire",
          description:
            "Notre bureau d'études réalise l'étude solaire et de stockage. Une fois que vous validez le projet solaire sur-mesure, nous réalisons un appel d'offres pour obtenir plusieurs devis.",
        },
        scams: {
          title: "Lutter contre les escrocs",
          description:
            "Nous encadrons le projet solaire : nous réalisons le dossier technique, organisons la visite technique obligatoire, puis les démarches administratives, financières et assurancielles.",
        },
        climate: {
          title: "Impact sur le climat",
          description:
            "Vous aider à faire savoir le photovoltaïque de nouvelle génération, esthétique et puissant. Le gisement d'énergie solaire propre durera des décennies, réduisant la pollution.",
        },
      },
      cta: "Étapes d'une installation photovoltaïque",
      testimonial: {
        quote:
          "“J'ai déjà parrainé 8 amis et ma maman ! Quatre sont passés à l'acte, j'ai gagné 2 mille euros !”",
        author: "Jean",
        location: "Aix-en-Provence",
      },
    },
    how: {
      title: "Comment faire ?",
      description:
        "Étapes simples qui ne nécessitent qu'une facture d'électricité pour démarrer.",
      step1: {
        title: "Inscrivez-vous gratuitement",
        description:
          "Inscrivez-vous en 2 minutes pour faire connaissance. Oui, c'est gratuit.",
      },
      step2: {
        title: "Téléchargez une facture d'électricité",
        description:
          "Discutez avec un propriétaire des avantages de l'énergie solaire.",
      },
      step3: {
        title: "Partagez l'étude puis les devis",
        description:
          "Vous n'avez rien à faire, à part peut-être montrer l'étude. Recevez 500 € à la pose.",
      },
    },
    tools: {
      title: "Nos outils",
      description:
        "Nous vous donnons accès à des outils pour vous faciliter la tâche.",
      tool1: {
        title: "Formation :",
        description:
          "Bénéficiez d'une formation complète pour pouvoir vous lancer dans l’aventure solaire en toute sérénité ! ",
      },
      tool2: {
        title: "Accompagnement :",
        description:
          "Vous recevrez du matériel marketing pour vous aider à atteindre vos objectifs. ",
      },
    },
    faq: {
      title: "Questions Fréquentes (FAQ) :",
      q1: {
        question: "Comment fonctionne le programme d'ambassadeur ?",
        respond:
          "Notre programme d'ambassadeur vous récompense chaque fois que vous recommandez un client qui signe un devis avec nous. Plus vous recommandez, plus vous gagnez.",
      },
      q2: {
        question: "Y a-t-il des coûts associés à devenir ambassadeur ?",
        respond:
          "Non, l'inscription en tant qu'ambassadeur est entièrement gratuite.",
      },

      q3: {
        question:
          "Ai-je besoin de connaissances préalables en énergie solaire ?",
        respond:
          "Non, nous fournissons une formation complète pour vous préparer à promouvoir nos services.",
      },
    },
    cta: {
      title: "Parrainez aujourd'hui pour recevoir plusieurs devis d'artisans",
      description:
        "C'est aussi simple que ça de contribuer à éliminer des tonnes de CO2 de l'atmosphère. Et plus vous parrainez de personnes, plus vous avez de chances de recevoir 500 € par parrainage, versés directement sur votre compte bancaire.",
      button: "Je parraine !",
    },
    banner: {
      paragraph:
        "Parrainez aujourd'hui pour recevoir plusieurs devis d'artisans",
      description:
        "C'est aussi simple que ça de contribuer à éliminer des tonnes de CO2 de l'atmosphère. Et plus vous parrainez de personnes, plus vous avez de chances de recevoir 500 € par parrainage, versés directement sur votre compte bancaire.",
      button: "Je parraine !",
    },
  },
  "sign-in": {
    title: "Bienvenu, aidez nous à croitre le photovoltaïque en France !",
  },
  faq: {
    title:
      "Nos réponses à vos questions concernant le bouche-à-oreille rémunéré",
  },
}
